import React, {useEffect, useState} from 'react'

import {Alert, AlertTitle, Snackbar, Switch} from '@mui/material'
import {useSelector} from 'react-redux'
import {selectedSiteSelector} from '../authentication/redux'
import {useTranslation} from 'react-i18next'
import axios from 'axios'

type Props = {
    enabled: boolean
    onSwitch: (enabled : boolean) => void
    enabledSuccessMessage: string,
    disabledSuccessMessage: string,
    readonly?: boolean
}

export const EnableBusySwitch = ({ enabled, onSwitch, enabledSuccessMessage, disabledSuccessMessage, readonly }: Props) => {
    const [checked, setChecked] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState<boolean>(false)
    const { t } = useTranslation()

    const site = useSelector(selectedSiteSelector)

    useEffect(() => {
        setChecked(enabled)
    }, [enabled])

    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked)
        if (site) {
            try {
                onSwitch(event.target.checked)

                setSuccess(true)
            } catch (err) {
                setChecked(!event.target.checked)
                setSuccess(false)
                if (axios.isAxiosError(err)) {
                    const data = err?.response?.data as [any]
                    if (err.response?.status === 400 && !!data) {
                        data.forEach(serverError => setError(`general.form-error.${serverError.key}`))
                    } else {
                        setError('general.unknown-server-error')
                    }
                } else {
                    setError('general.unknown-server-error')
                }
                return
            }
        }
    }

    return (
        <>
            {<Switch size="small" onChange={handleChange} checked={checked} disabled={readonly}/>}
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={!!error} autoHideDuration={5000} onClose={() => setError(null)}>
                <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
                    <AlertTitle>{t('general.error')}</AlertTitle>
                    {error && t(error)}
                </Alert>
            </Snackbar>
            {<Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={success} autoHideDuration={3000} onClose={() => setSuccess(false)}>
                <Alert onClose={() => setSuccess(false)} severity="success" sx={{ width: '100%' }}>
                    <AlertTitle>{t('general.succeeded')}</AlertTitle>
                    {checked? enabledSuccessMessage : disabledSuccessMessage}
                </Alert>
            </Snackbar>}
        </>
    )
}
